module.exports = __webpack_public_path__ + "img/modal-folios-upload.8870542b.svg";